<section class="centered-with-padding pb-28 pt-16 desk:pb-52 desk:pt-24">
  <div class="grid grid-cols-1 gap-x-28 gap-y-12 desk:grid-cols-[auto_1fr]">
    <div class="mx-auto w-2/3 desk:w-full">
      <app-svg [isPriority]="!isImageInPreviousBlocks" [src]="data.picto.svg" />
    </div>
    <div>
      <app-title [title]="{ text: data.title, as: 'span' }" size="custom-40-60"></app-title>
      <div class="mt-6 desk:mt-8">{{ data.text }}</div>
    </div>
  </div>
</section>
